import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '../../../../../assets/images/chat/down-arrow.png'


const _hoisted_1 = { class: "thread-header w-100 d-flex justify-content-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */)
const _hoisted_3 = { class: "thread-date" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "dropdown ms-2"
}
const _hoisted_6 = {
  class: "cursor-pointer",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
const _hoisted_8 = { class: "dropdown-menu" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "#"
}, "Mark as Resolved", -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "thread-card" }
const _hoisted_12 = { class: "thread-message thread-message-original" }
const _hoisted_13 = { class: "message-header" }
const _hoisted_14 = { class: "sender-info" }
const _hoisted_15 = { class: "weight-600" }
const _hoisted_16 = { class: "sender-name" }
const _hoisted_17 = { class: "sender-meta" }
const _hoisted_18 = { class: "sender-meta" }
const _hoisted_19 = { class: "message-time pe-1" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "message-header" }
const _hoisted_23 = { class: "sender-info" }
const _hoisted_24 = { class: "weight-600" }
const _hoisted_25 = { class: "message-text" }
const _hoisted_26 = { class: "sender-name" }
const _hoisted_27 = { class: "sender-meta" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "message-time" }
const _hoisted_30 = {
  key: 0,
  class: "reply-section"
}
const _hoisted_31 = {
  key: 1,
  class: "reply-input-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageInputHandler = _resolveComponent("MessageInputHandler")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.formatDateToLocalBasedOnDayMode(_ctx.thread.createdOn)), 1 /* TEXT */),
      (_ctx.thread)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", {
              class: _normalizeClass(`status-pill status-pill-${_ctx.thread.conversationThreadStatus}`)
            }, _toDisplayString(_ctx.ThreadStatus.getDescriptionUsingValue(_ctx.thread.conversationThreadStatus)), 3 /* TEXT, CLASS */),
            (_ctx.thread.conversationThreadStatus !== _ctx.ThreadStatusEnum.Resolved && _ctx.canEditPatient)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("ul", _hoisted_8, [
                      _createElementVNode("li", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleResolve && _ctx.handleResolve(...args)))
                      }, _hoisted_10)
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createCommentVNode(" Original message (static, never scrolls) "),
      _createElementVNode("div", _hoisted_12, [
        _createCommentVNode(" Header row "),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: _normalizeClass(`ava-initials ava-initials-${_ctx.getSolutionClassIndex(1)}`)
            }, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatUserInitials(_ctx.thread?.createdByUser)), 1 /* TEXT */)
            ], 2 /* CLASS */),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_16, [
                _createTextVNode(_toDisplayString(_ctx.formatDisplayUsers([_ctx.thread?.createdByUser])) + " ", 1 /* TEXT */),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.thread.createdByUser?.relationship ? `  (${_ctx.thread.createdByUser.relationship})` : ""), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.patientAgencyName), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.formatDateTimeToLocal(_ctx.thread.createdOn)), 1 /* TEXT */)
        ]),
        _createCommentVNode(" Subject only for first message "),
        (_ctx.thread.subject)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "message-subject",
              innerHTML: _ctx.sanitizeMarkup(_ctx.markdownToHtml(_ctx.thread.subject))
            }, null, 8 /* PROPS */, _hoisted_20))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Body "),
        _createElementVNode("div", {
          class: "message-body",
          innerHTML: _ctx.sanitizeMarkup(_ctx.markdownToHtml(_ctx.thread.body))
        }, null, 8 /* PROPS */, _hoisted_21)
      ]),
      _createCommentVNode(" Replies (scrollable) "),
      (_ctx.thread.messages?.length > 0 || _ctx.showLoadMoreReplies)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["thread-replies pe-2", { 'custom-scrollbar': _ctx.userOs == 'Windows' }]),
            ref: "threadMessages"
          }, [
            (_ctx.showLoadMoreReplies)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "load-more-replies",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadMoreMessages && _ctx.loadMoreMessages(...args)))
                }, " Open " + _toDisplayString(_ctx.remainingRepliesCount) + " more replies ", 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thread.messages, (message, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: message.id,
                class: "thread-message"
              }, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`ava-initials ava-initials-${_ctx.getSolutionClassIndex(index)}`)
                    }, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.formatUserInitials(message?.senderUser)), 1 /* TEXT */)
                    ], 2 /* CLASS */),
                    _createCommentVNode(" Right side text column "),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.formatDisplayUsers([message.senderUser])), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_27, _toDisplayString(message.senderUser?.isFamilyPortalUser
                                        ? message.senderUser?.relationship
                                            ? message.senderUser.relationship
                                            : _ctx.patientAgencyName
                                        : " "), 1 /* TEXT */),
                      _createCommentVNode(" Body under name "),
                      _createElementVNode("div", {
                        class: "message-body",
                        innerHTML: _ctx.sanitizeMarkup(_ctx.markdownToHtml(message.body))
                      }, null, 8 /* PROPS */, _hoisted_28)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.formatDateTimeToLocal(message.createdOn)), 1 /* TEXT */)
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Reply "),
      (_ctx.thread.conversationThreadStatus !== _ctx.ThreadStatusEnum.Resolved && _ctx.canEditPatient)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!_ctx.showReply)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("button", {
                    class: "reply-link",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleshowReply && _ctx.handleshowReply(...args)))
                  }, "Reply to thread")
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.showReply)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("div", {
                    class: "w-100 cursor-pointer text-end pe-2",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showReply = false))
                  }, "Cancel"),
                  _createVNode(_component_MessageInputHandler, {
                    send: _ctx.sendMessage,
                    threadId: _ctx.thread.id,
                    "refs-name": `threadEditorRef-${_ctx.thread.id}`,
                    "toggle-important": _ctx.toggleImportant,
                    isFamilyPortal: true
                  }, null, 8 /* PROPS */, ["send", "threadId", "refs-name", "toggle-important"])
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}